import React from "react";
import { motion } from "framer-motion";
import { Sprout, Leaf } from "lucide-react";

// A plant that literally grows as net worth grows (the Burgeon motif).
export const GrowthMascot = ({ session }) => {
  const start = session.starting_net_worth || 1;
  const ratio = session.net_worth / (start || 1);
  let tier = 2;
  if (session.net_worth <= 0) tier = 0;
  else if (ratio < 0.75) tier = 1;
  else if (ratio < 1) tier = 2;
  else if (ratio < 1.5) tier = 3;
  else tier = 4;

  const labels = ["Wilting", "Sprouting", "Growing", "Thriving", "Flourishing"];
  const leaves = tier;
  const iconSize = 20 + tier * 5;

  return (
    <div
      data-testid="growth-mascot"
      className="flex items-center gap-3 rounded-2xl border border-emerald-500/25 bg-gradient-to-b from-emerald-500/[0.08] to-transparent bg-slate-900/50 px-4 py-3"
    >
      <div className="relative w-12 h-12 rounded-full bg-emerald-500/15 border border-emerald-500/30 flex items-end justify-center overflow-hidden">
        <motion.div
          key={tier}
          initial={{ scale: 0.6, opacity: 0.6, y: 6 }}
          animate={{ scale: 1, opacity: 1, y: 0 }}
          transition={{ type: "spring", stiffness: 260, damping: 16 }}
          className="pb-1"
        >
          <Sprout className="text-emerald-400" style={{ width: iconSize, height: iconSize }} strokeWidth={2.2} />
        </motion.div>
      </div>
      <div className="leading-tight">
        <p className="text-[10px] uppercase tracking-wider text-slate-500 font-semibold">Your growth</p>
        <p className="text-sm font-bold text-emerald-300">{labels[tier]}</p>
        <div className="flex gap-0.5 mt-0.5">
          {[0, 1, 2, 3].map((i) => (
            <Leaf key={i} className={`w-3 h-3 ${i < leaves ? "text-emerald-400" : "text-slate-700"}`} />
          ))}
        </div>
      </div>
    </div>
  );
};
